import { Component, Input, OnInit } from '@angular/core';
import { NzButtonComponent } from "ng-zorro-antd/button";
import { NzIconDirective } from "ng-zorro-antd/icon";
import { TablaComponent } from "../../../../../core/components/tabla/tabla.component";
import { Organizacion } from '../../../../../core/interfaces/utilidades/pJuridica.interface';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { PJuridicaService } from '../../../../../core/services/p-juridica.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FormularioGeneralComponent } from '../../../../../core/components/formulario-general/formulario-general.component';
import { Validators } from '@angular/forms';
import { TipoInstitucionService } from '../../../../../core/services/tipo-institucion.service';

@Component({
  selector: 'app-organizaciones',
  imports: [
    NzButtonComponent,
    NzIconDirective,
    TablaComponent,
    NzModalModule
  ],
  templateUrl: './organizaciones.component.html',
  styleUrl: './organizaciones.component.css'
})

export class OrganizacionesComponent implements OnInit {

  constructor(
    private modal: NzModalService,
    private pjuridicaService: PJuridicaService,
    private message: NzMessageService,
    private tipoInstitucionService: TipoInstitucionService
  ) {}

  columns = [
    { title: 'Nombre', key: 'razon_social' },
    { title: 'RUC', key: 'ruc' },
    { title: 'Celular', key: 'celular' },
    { title: 'Tipo de Institución', key: 'nombre_institucion' }
  ];

  listOfData: Organizacion[] = [];
  tiposInstitucion: any[] = [];
  @Input() disableButtons!: boolean;

  ngOnInit(): void {
    this.loadOrganizaciones();
    this.loadTiposInstitucion();
  }

  loadOrganizaciones(): void {
    this.pjuridicaService.getOrganizaciones().subscribe(
      (organizaciones: Organizacion[]) => {
        this.listOfData = organizaciones;
        this.listOfData.forEach(org => {
          if (org.tipo_institucion && org.tipo_institucion.id_tipo_institucion) {
            org.nombre_institucion = org.tipo_institucion.nombre_institucion;
          } else {
            org.nombre_institucion = 'Unknown'; // Default value if id_tipo_institucion is undefined
            console.error('id_tipo_institucion is undefined for organization', org);
          }
        });
      },
      (error) => {
        console.error('Error al cargar las organizaciones', error);
      }
    );
  }
  loadTiposInstitucion(): void {
    this.tipoInstitucionService.getAll().subscribe(
      (tipos: any[]) => {
        this.tiposInstitucion = tipos.map(tipo => ({ label: tipo.nombre_institucion, value: tipo.id_tipo_institucion }));
        this.updateFormConfig();
        this.loadOrganizaciones(); // Load organizations after types are loaded
      },
      (error) => {
        console.error('Error al cargar los tipos de institución', error);
      }
    );
  }

  updateFormConfig(): void {
    this.formConfig.tipo_institucion.options = this.tiposInstitucion;
  }

  formConfig = {
    razon_social: { label: 'Razon Social', validators: [Validators.required, Validators.maxLength(45)] },
    ruc: { label: 'RUC', validators: [Validators.required, Validators.pattern(/^\d{11}$/)] },
    celular: { label: 'Celular', validators: [Validators.required, Validators.pattern(/^\d{9}$/)] },
    tipo_institucion: { label: 'Tipo de Institución', type: 'select', options: this.tiposInstitucion, validators: [Validators.required] }
  };

  showModal(): void {
    const modalRef = this.modal.create({
      nzTitle: 'Nueva Persona Jurídica',
      nzContent: FormularioGeneralComponent,
      nzData: {
        formConfig: this.formConfig,
        service: this.pjuridicaService,
      },
      nzFooter: null,
    });

    modalRef.afterClose.subscribe((result) => {
      if (result) {
        this.message.success('Persona Juridica creado exitosamente');
        this.loadOrganizaciones();
      }
    });
  }

  onEdit(row: Organizacion): void {
    const modalRef = this.modal.create({
      nzTitle: 'Editar Persona Juridica',
      nzContent: FormularioGeneralComponent,
      nzFooter: null,
      nzData: {
        formConfig: this.formConfig,
        initialData: row,
        service: this.pjuridicaService,
      },
    });

    modalRef.afterClose.subscribe((result) => {
      if (result) {
        this.message.success('Ciudadano editado exitosamente');
        this.loadOrganizaciones();
      }
    });
  }

  onDelete(row: any): void {
    this.pjuridicaService.deleteOrganizacion(row.id_persona_juridica).subscribe(
      () => {
        console.log('Ciudadano eliminado');
        this.loadOrganizaciones();
      },
      (error) => {
        console.error('Error al eliminar el ciudadano:', error);
      }
    );
  }
}
